import { Accordion as GardenAccordion } from '@zendeskgarden/react-accordions';
import type { IAccordion } from './interfaces';

export function Accordion({ items }: IAccordion) {
  return (
    <GardenAccordion
      level={4}
      isBare
      className="my-accordion border border-[#D8DCDE] rounded-[8px]"
    >
      <GardenAccordion.Section className='pb-4 px-4'>
        <GardenAccordion.Header>
          <GardenAccordion.Label className="font-semibold text-[14px]">
            {items.title}
          </GardenAccordion.Label>
        </GardenAccordion.Header>

        <GardenAccordion.Panel>
          <div className="font-medium text-[12px]">{items.content}</div>
        </GardenAccordion.Panel>
      </GardenAccordion.Section>
    </GardenAccordion>
  );
}
